module.exports = __webpack_public_path__ + "img/q3-2-active.964bdb65.png";